import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export interface DialogData {
	descriptionheaders: Array<any>;
	header: [];
	description: string;
}
@Component({
	selector: 'app-location-description-add',
	templateUrl: './location-description-add.component.html',
	styleUrls: ['./location-description-add.component.css'],
})
export class LocationDescriptionAddComponent {
	constructor(
		private readonly dialogRef: MatDialogRef<LocationDescriptionAddComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
	) {}
	editor = ClassicEditor;
	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};
	onCloseClick(): void {
		this.dialogRef.close();
	}
}
